<template>
  <div class="NewPropertyForm">
    <loader :isShow="isLoading" :textInfo="''" />
    <section class="FormHeader">
      <span class="Dot" :class="currentPart < 1 ? 'Green' : 'Grey'" />
      <hr class="Line" />
      <span class="Dot" :class="currentPart > 0 ? 'Green' : 'Grey'" />
      <div class="Descriptors">
        <span class="Label" :class="currentPart < 1 ? 'Green' : 'Grey'">
          Description
        </span>
        <span class="Label" :class="currentPart > 0 ? 'Green' : 'Grey'">
          Details
        </span>
      </div>
    </section>

    <section class="FormBody" v-if="currentPart === 0">
      <div class="Subtitle HEL">{{ this.subtitle }}</div>
      <div v-if="incompleteForm" class="ErrorMessage">
        * {{ requiredFieldsError }}
      </div>

      <div class="Grouped HEL">
        <label>Internal Name</label>
        <input
          class="TallInput"
          :class="{ Error: !this.validInternalName }"
          v-model="data.internalName"
        />
      </div>
      <div class="Grouped HEL">
        <label>Marketing Name</label>
        <input
          class="TallInput"
          :class="{ Error: !this.validMarketingName }"
          v-model="data.marketingName"
        />
      </div>

      <div class="Grouped HEL">
        <label>Search</label>
        <GmapAutocomplete
          :options="{
            fields: [
              'geometry',
              'formatted_address',
              'address_components',
              'utc_offset_minutes'
            ]
          }"
          @place_changed="getLocationDetails"
          class="TallInput"
        />
      </div>

      <div class="Row HEL">
        <div class="Column">
          <label>Address</label>
          <input
            class="TallInput"
            :class="{ Error: !this.validAddress }"
            v-model="data.address"
          />
        </div>
        <div class="Column">
          <label>Apt/Suite/Unit/Building</label>
          <input class="TallInput" v-model="data.address2" />
        </div>
      </div>
      <div class="Row HEL">
        <div class="Column">
          <label>City</label>
          <input
            class="TallInput"
            :class="{ Error: !this.validCity }"
            v-model="data.city"
          />
        </div>
        <div class="Column">
          <label>Country</label>
          <country-select
            class="TallerInput"
            :class="{ Error: !this.validCountry }"
            :country="data.country"
            v-model="data.country"
            :countryName="true"
          />
        </div>
      </div>
      <div class="Row HEL">
        <div class="Column">
          <label>State</label>
          <region-select
            class="TallerInput"
            :class="{ Error: !this.validState }"
            :country="data.country"
            v-model="data.state"
            :region="data.state"
            :countryName="true"
            :regionName="true"
          />
        </div>
        <div class="Column">
          <label>ZIP code</label>
          <input
            class="TallInput"
            :class="{ Error: !this.validZipcode }"
            v-model="data.zipcode"
            type="text"
            pattern="[0-9]*"
          />
        </div>
      </div>
      <div>
        <GmapMap :center="coordinates" :zoom="10" ref="gmap" class="Gmap HEL">
          <GmapMarker :position="coordinates" />
        </GmapMap>
      </div>
    </section>

    <section class="FormBody" v-if="currentPart === 1">
      <div class="Subtitle HEL">{{ this.subtitle }}</div>
      <div class="new-property-warning-message" v-if="validTimezone == false">
        <img src="../../assets/warning.svg" alt="warning sign" />
        <label> Timezone does not correspond to address provided </label>
      </div>
      <div class="new-property-warning-message" v-if="validImage == false">
        <img src="../../assets/warning.svg" alt="warning sign" />
        <label> At least 1 photo is required to create a property </label>
      </div>
      <div class="Grouped HEL">
        <label>Property Timezone</label>
        <select class="TallInput" v-model="selectedTimezone">
          <option :value="null">Select Timezone</option>
          <option
            v-for="timezone in validMomentTimezones"
            :value="timezone"
            :key="'timezone-' + timezone"
          >
            {{ timezone }}
          </option>
        </select>
      </div>

      <div v-if="incompleteForm" class="ErrorMessage">
        * {{ requiredFieldsError }}
      </div>
      <div class="Row HEL">
        <div class="Column">
          <label>Arrival</label>
          <div class="DoubleSelect">
            <select class="TallInput" v-model="data.checkin.hours">
              <option v-for="hour of hours" :value="hour" :key="hour">
                {{ hour }}
              </option>
            </select>
            <select class="TallInput" v-model="data.checkin.minutes">
              <option v-for="minute of minutes" :value="minute" :key="minute">
                {{ minute }}
              </option>
            </select>
          </div>
        </div>
        <div class="Column">
          <label>Departure</label>
          <div class="DoubleSelect">
            <select class="TallInput" v-model="data.checkout.hours">
              <option v-for="hour of hours" :value="hour" :key="hour">
                {{ hour }}
              </option>
            </select>
            <select class="TallInput" v-model="data.checkout.minutes">
              <option v-for="minute of minutes" :value="minute" :key="minute">
                {{ minute }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="Grouped HEL">
        <label>House Manual</label>
        <input
          type="url"
          class="TallInput"
          placeholder="Enter house manual url"
          v-model="data.houseManual"
        />
      </div>
      <div class="create-property-photo-container">
        <div class="create-property-title">Add photos</div>
        <div class="create-property-subtitle-container">
          <div class="create-property-subtitle">
            Photos helps housemates to know the property better
          </div>
        </div>

        <div class="create-property-image-area-container">
          <div
            :style="dragAreaStyle"
            class="create-property-drag-area"
            @dragleave="dragleave"
            @dragover="dragover"
            @drop="drop"
          >
            <input
              ref="file"
              type="file"
              accept=".png,.jpeg, .jpg"
              id="file-upload"
              @change="uploadFile"
              hidden
            />
            <button class="create-property-upload-button" @click="promptUpload">
              Upload Photos
            </button>
            <div class="create-property-drag-hint">Or drag them here</div>
          </div>

          <div
            v-if="imagesData.length > 0"
            :style="editImageContainerStyle"
            class="create-property-edit-image-container"
          >
            <div
              v-for="(data, index) in imagesData"
              :key="'image-container-' + index"
              class="create-property-edit-image-sub-container"
            >
              <progress
                v-if="data.uploadProgress > 0"
                :value="data.uploadProgress"
                max="100"
                class="upload-progress"
              />
              <img
                :key="'button-' + index"
                @click="removeImage(index)"
                title="Delete Image"
                alt="Delete Image"
                class="create-property-trash-icon"
                src="../../assets/TrashButton.svg"
              />
              <img
                :key="'image-' + index"
                :src="data.url"
                class="create-property-edit-image"
              />
              <img
                :key="'feature-unselected' + index"
                class="create-property-feature-image"
                src="../../assets/FeatureStarSelected.svg"
                v-if="featureImage == index"
              />
              <div class="create-property-feature-image-wrapper">
                <img
                  @click="setFeatureImage(index)"
                  :key="'feature-selected' + index"
                  class="create-property-feature-image"
                  src="../../assets/FeatureStarUnselected.svg"
                  v-if="featureImage != index"
                />
                <span class="tooltip">Set as feature image</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="FormFooter">
      <button @click="goBack" class="Btn">&lt; Back</button>
      <button @click="goForward" class="Btn Next">
        {{ this.nextButtonText }}
      </button>
    </section>
  </div>
</template>

<script>
import calls from '@/api/calls'
//import geocodeCall from '@/api/geocodeCalls'
// import Multiselect from "vue-multiselect"
import 'vue-multiselect/dist/vue-multiselect.min.css'
import firebase from 'firebase'
import moment from 'moment-timezone'
import { compressImageForUpload } from '@/functions/imageCompression'
import { validateFields, ERRORS } from '@/functions/validation.js'
import Loader from '@/components/Loader.vue'

export default {
  name: 'NewPropertyScreen',
  components: {
    Loader
  },
  data() {
    return {
      isLoading: false,
      selectedTimezone: null,
      validMomentTimezones: [
        'Etc/GMT+12',
        'Pacific/Pago_Pago',
        'Pacific/Midway',
        'Pacific/Honolulu',
        'America/Juneau',
        'America/Los_Angeles',
        'America/Tijuana',
        'America/Phoenix',
        'America/Chihuahua',
        'America/Mazatlan',
        'America/Denver',
        'America/Guatemala',
        'America/Chicago',
        'America/Mexico_City',
        'America/Monterrey',
        'America/Regina',
        'America/Bogota',
        'America/New_York',
        'America/Indiana/Indianapolis',
        'America/Lima',
        'America/Halifax',
        'America/Caracas',
        'America/Guyana',
        'America/La_Paz',
        'America/Puerto_Rico',
        'America/Santiago',
        'America/St_Johns',
        'America/Sao_Paulo',
        'America/Argentina/Buenos_Aires',
        'America/Godthab',
        'America/Montevideo',
        'Atlantic/South_Georgia',
        'Atlantic/Azores',
        'Atlantic/Cape_Verde',
        'Africa/Casablanca',
        'Europe/London',
        'Europe/Lisbon',
        'Africa/Monrovia',
        'Etc/UTC',
        'Europe/Amsterdam',
        'Europe/Belgrade',
        'Europe/Berlin',
        'Europe/Zurich',
        'Europe/Bratislava',
        'Europe/Brussels',
        'Europe/Budapest',
        'Europe/Copenhagen',
        'Europe/Dublin',
        'Europe/Ljubljana',
        'Europe/Madrid',
        'Europe/Paris',
        'Europe/Prague',
        'Europe/Rome',
        'Europe/Sarajevo',
        'Europe/Skopje',
        'Europe/Stockholm',
        'Europe/Vienna',
        'Europe/Warsaw',
        'Africa/Algiers',
        'Europe/Zagreb',
        'Europe/Athens',
        'Europe/Bucharest',
        'Africa/Cairo',
        'Africa/Harare',
        'Europe/Helsinki',
        'Asia/Jerusalem',
        'Europe/Kaliningrad',
        'Europe/Kiev',
        'Africa/Johannesburg',
        'Europe/Riga',
        'Europe/Sofia',
        'Europe/Tallinn',
        'Europe/Vilnius',
        'Asia/Baghdad',
        'Europe/Istanbul',
        'Asia/Kuwait',
        'Europe/Minsk',
        'Europe/Moscow',
        'Africa/Nairobi',
        'Asia/Riyadh',
        'Europe/Volgograd',
        'Asia/Tehran',
        'Asia/Muscat',
        'Asia/Baku',
        'Europe/Samara',
        'Asia/Tbilisi',
        'Asia/Yerevan',
        'Asia/Kabul',
        'Asia/Yekaterinburg',
        'Asia/Karachi',
        'Asia/Tashkent',
        'Asia/Kolkata',
        'Asia/Colombo',
        'Asia/Kathmandu',
        'Asia/Almaty',
        'Asia/Dhaka',
        'Asia/Urumqi',
        'Asia/Rangoon',
        'Asia/Bangkok',
        'Asia/Jakarta',
        'Asia/Krasnoyarsk',
        'Asia/Novosibirsk',
        'Asia/Shanghai',
        'Asia/Chongqing',
        'Asia/Hong_Kong',
        'Asia/Irkutsk',
        'Asia/Kuala_Lumpur',
        'Australia/Perth',
        'Asia/Singapore',
        'Asia/Taipei',
        'Asia/Ulaanbaatar',
        'Asia/Tokyo',
        'Asia/Seoul',
        'Asia/Yakutsk',
        'Australia/Adelaide',
        'Australia/Darwin',
        'Australia/Brisbane',
        'Australia/Melbourne',
        'Pacific/Guam',
        'Australia/Hobart',
        'Pacific/Port_Moresby',
        'Australia/Sydney',
        'Asia/Vladivostok',
        'Asia/Magadan',
        'Pacific/Noumea',
        'Pacific/Guadalcanal',
        'Asia/Srednekolymsk',
        'Pacific/Auckland',
        'Pacific/Fiji',
        'Asia/Kamchatka',
        'Pacific/Majuro',
        'Pacific/Chatham',
        'Pacific/Tongatapu',
        'Pacific/Apia',
        'Pacific/Fakaofo'
      ],
      currentPart: 0,
      subtitle: 'Description',
      data: {
        internalName: null,
        marketingName: null,
        latitude: 0,
        longitude: 0,
        country: null,
        state: null,
        staff: [],
        users: [],
        checkin: {
          minutes: '00',
          hours: '10'
        },
        checkout: {
          minutes: '00',
          hours: '16'
        },
        images: null,
        utc_offset: null
      },
      coordinates: {
        lat: 0,
        lng: 0
      },
      map: null,
      zoom: 10,
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23'
      ],
      minutes: ['00', '15', '30', '45'],
      staff: [],
      users: [],
      requiredFieldsPart0: [
        'internalName',
        'marketingName',
        'address',
        'city',
        'zipcode',
        'state',
        'country'
      ],
      incompleteForm: false,
      imagesData: [],
      dragging: false,
      featureImage: 0,

      //validators
      validInternalName: true,
      validMarketingName: true,
      validAddress: true,
      validCity: true,
      validState: true,
      validZipcode: true,
      validCountry: true,
      validTimezone: true,
      validImage: true,
      nextButtonText: 'Next',
      utc_offset_minutes: 0
    }
  },
  computed: {
    requiredFieldsError() {
      return ERRORS.REQUIRED_FIELDS
    },
    dragAreaStyle() {
      return {
        'min-height': this.imagesData.length > 0 ? '100px' : '350px',
        background: this.dragging ? 'rgba(155, 165, 145, 0.2)' : '#EBF0E6'
      }
    },
    editImageContainerStyle() {
      return {
        overflow: this.imagesData.length > 4 ? 'scroll' : 'hidden',
        'grid-template-rows': `repeat(${Math.ceil(
          this.imagesData.length / 2
        )}, 50%)`
      }
    }
  },
  methods: {
    validateTimezone() {
      return true
    },
    setFeatureImage(index) {
      this.featureImage = index
    },
    goBack() {
      this.currentPart -= 1
      this.subtitle = 'Description'
      if (this.currentPart < 0) {
        this.currentPart = 0
        this.$router.replace('/listings/properties')
      }
      this.nextButtonText = 'Next'
    },
    async goForward() {
      this.subtitle = 'Details'
      this.incompleteForm = false

      if (this.currentPart == 0) {
        const { valid, invalidFields } = validateFields(
          this.requiredFieldsPart0,
          this.data
        )
        this.validInternalName = !invalidFields.includes('internalName')
        this.validMarketingName = !invalidFields.includes('marketingName')
        this.validAddress = !invalidFields.includes('address')
        this.validCity = !invalidFields.includes('city')
        this.validZipcode = !invalidFields.includes('zipcode')
        this.validState = !invalidFields.includes('state')
        this.validCountry = !invalidFields.includes('country')
        this.incompleteForm = !valid
        if (this.incompleteForm) return
      }

      this.nextButtonText = 'Save'
      if (this.currentPart == 1) {
        this.validImage = true
        this.validTimezone = this.validateTimezone()
        if (!this.validTimezone) {
          return
        }
        const request_body = {
          internalName: this.data.internalName,
          marketingName: this.data.marketingName,
          country: this.data.country,
          city: this.data.city,
          state: this.data.state,
          address: this.data.address,
          zipcode: this.data.zipcode,
          utcoffset: this.data.utc_offset,
          checkin: this.data.checkin.hours + ':' + this.data.checkin.minutes,
          checkout: this.data.checkout.hours + ':' + this.data.checkout.minutes,
          timezone: this.selectedTimezone,
          images: this.data.images,
          featureImage: `${this.featureImage}`,
          latitude: this.coordinates.lat,
          longitude: this.coordinates.lng
        }
        if (this.data.address2) {
          request_body.address2 = this.data.address2
        }
        let response = null
        if (this.$route.params.id) {
          response = await calls.PUT(
            'properties',
            this.$route.params.id,
            request_body
          )
        } else {
          response = await calls.POST('properties', request_body)
        }
        const { message } = response
        if (message) {
          if (message === '"images" must be a string') {
            this.validImage = false
          }
          this.$notify({
            group: 'rent-mgt-notification',
            type: 'error',
            text: message
          })
        } else {
          this.$router.replace('/listings/properties')
        }
      }
      this.currentPart = 1
    },
    async getLocationDetails(event) {
      let country, state, city, zipcode, street, street_num
      for (let ac of event.address_components) {
        if (['political', 'country'].every((t) => ac.types.includes(t))) {
          country = ac.long_name
        } else if (
          ['political', 'administrative_area_level_1'].every((t) =>
            ac.types.includes(t)
          )
        ) {
          state = ac.long_name
        } else if (
          ['political', 'locality'].every((t) => ac.types.includes(t))
        ) {
          city = ac.long_name
        } else if (ac.types.includes('postal_code')) {
          zipcode = ac.long_name
        } else if (ac.types.includes('route')) {
          street = ac.long_name
        } else if (ac.types.includes('street_number')) {
          street_num = ac.long_name
        }
      }
      this.data.country = country
      await this.$nextTick()
      this.data.state = state
      this.data.city = city
      this.data.zipcode = zipcode
      if (street_num && street) this.data.address = street_num + ' ' + street
      this.coordinates.lat = event.geometry.location.lat()
      this.coordinates.lng = event.geometry.location.lng()
      let offset_hours = Math.abs(Math.floor(event.utc_offset_minutes / 60))
      let subres1 = offset_hours >= 10 ? `${offset_hours}` : `0${offset_hours}`
      let offset_minutes = event.utc_offset_minutes % 60
      let subres2 =
        offset_minutes >= 10 ? `${offset_minutes}` : `0${offset_minutes}`
      let res = [subres1, subres2].join('')
      if (event.utc_offset_minutes >= 0) {
        res = '+' + res
      } else {
        res = '-' + res
      }
      this.data.utc_offset = res
      this.utc_offset_minutes = event.utc_offset_minutes
    },
    async promptUpload() {
      document.getElementById('file-upload').click()
    },
    async uploadFile() {
      let file = this.$refs.file.files[0]
      if (!file) return

      try {
        file = await compressImageForUpload(file)
      } catch (error) {
        console.error(error.message)
      }

      const newImage = {
        uploadProgress: 0,
        url: ''
      }
      const currentIndex = this.imagesData.length
      this.imagesData.push(newImage)
      const storageRef = firebase.storage().ref(`${file.name}`).put(file)
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.imagesData[currentIndex].uploadProgress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 90
        },
        (error) => console.error(error.message),
        () => {
          this.imagesData[currentIndex].uploadProgress = 90
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.imagesData[currentIndex].uploadProgress = 100
            this.imagesData[currentIndex].url = url
            const auxurls = this.imagesData.map((e) => e.url)
            this.data.images = auxurls.join(',')
            setTimeout(() => {
              this.imagesData[currentIndex].uploadProgress = 0
            }, 5000)
          })
        }
      )
    },
    removeImage(index) {
      this.imagesData.splice(index, 1)
      const auxurls = this.imagesData.map((e) => e.url)
      this.data.images = auxurls.join(',')
    },
    dragover(event) {
      event.preventDefault()
      this.dragging = true
    },
    dragleave() {
      this.dragging = false
    },
    drop(event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.uploadFile()
    }
  },
  async created() {
    this.isLoading = true
    try {
      const { id, part } = this.$route.params
      if (id) {
        try {
          const { data } = await calls.GET(`properties/${id}`)
          this.data.internalName = data.internalName
          this.data.marketingName = data.marketingName
          this.data.country = data.country
          this.data.latitude = data.latitude
          this.data.longitude = data.longitude
          this.coordinates.lat = data.latitude
          this.coordinates.lng = data.longitude
          await this.$nextTick()
          this.data.state = data.state
          this.data.city = data.city
          this.data.zipcode = data.zipcode
          this.data.address = data.address
          this.selectedTimezone = data.timezone
          this.data.utc_offset = data.utcoffset

          if (data.address2) {
            this.data.address2 = data.address2
          }
          if (data.checkin) {
            const time = data.checkin.split(':')
            this.data.checkin.hours = time[0]
            this.data.checkin.minutes = time[1]
          }
          if (data.checkout) {
            const time = data.checkout.split(':')
            this.data.checkout.hours = time[0]
            this.data.checkout.minutes = time[1]
          }
          const aux = (data.images || '').split(',').map((e) => e.trim())
          for (let img of aux) {
            this.imagesData.push({
              uploadProgress: 0,
              url: img
            })
          }
          this.data.images = data.images
          if (data.featureImage) this.featureImage = data.featureImage
          document.title = `Rentalios | ${this.data.internalName}`
        } catch (e) {
          console.error(e.message)
        }
      }
      try {
        const { data } = await calls.GET('users')
        this.users = data
      } catch (e) {
        console.error(e.message)
      }
      if (part == 1) this.goForward()
    } finally {
      this.isLoading = false
    }
  },
  async mounted() {
    this.map = await this.$refs.gmap.$mapPromise
  }
}
</script>

<style scoped>
.NewPropertyForm {
  background-color: #f5f6f8;
  padding: 24px;
  display: flex;
  flex-flow: column nowrap;
}
.FormHeader {
  height: 90px;
  background-color: #ebf0e6;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}
.FormHeader .Dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
  margin: 30px 0 0 0;
  border-style: solid;
  border-width: 2px;
  border-color: white;
}
.FormHeader .Dot.Green {
  background-color: var(--rentalios-dark);
}
.FormHeader .Dot.Grey {
  background-color: #bdbdbd;
}
.FormHeader .Line {
  display: inline-block;
  width: 148px;
  margin: 0 0 6px 0;
  padding: 0 0 0 0;
  border: none;
  height: 2px;
  background-color: #bdbdbd;
}

.FormHeader .Descriptors {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 230px;
  margin: 0 0 0 calc(50% - 115px);
}

.FormHeader .Descriptors .Label {
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  height: 15px;
  width: 71px;
  left: 0px;
  top: 20px;
}
.FormHeader .Descriptors .Label.Grey {
  color: #bdbdbd;
}
.FormHeader .Descriptors .Label.Green {
  color: var(--rentalios-dark);
}
.Subtitle {
  width: 158.25px;
  height: 22px;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #66b015;
}

.FormBody {
  /* height: 44vh; */
  /* overflow-y: scroll; */
  padding: 24px 25%;
  background-color: white;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
}
.FormBody .Row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 0 0 0;
}

.FormBody .Column {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 0;
  width: 48%;
}

.FormBody .Column .DoubleSelect {
  flex-flow: row nowrap;
  justify-content: space-between;
  display: flex;
  align-content: center;
}
.FormBody .Column .DoubleSelect Select {
  width: 100%;
  margin-right: 10px;
}
.TallInput {
  height: 40px;
  border: solid 1px;
  border-radius: 4px;
  border-color: #cbd4dc;
  margin: 0;
  padding: 0;
  padding-left: 8px;
}
.TallerInput {
  height: 42px;
  border: solid 1px;
  border-radius: 4px;
  border-color: #cbd4dc;
}
.multiselect {
  border: solid 1px;
  border-radius: 6px;
  border-color: #cbd4dc;
}

.multiselect.Error {
  border-color: red;
}

.FormBody .Grouped {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border-color: #cbd4dc;
}
.FormFooter {
  height: 80px;
  border-top: solid 1px #dfdfdf;
  background-color: white;
  display: flex;
  justify-content: space-between;
  padding: 2% 25% 0 25%;
}
.FormFooter .Btn:hover {
  text-decoration: underline;
}

.FormFooter .Btn {
  height: 48px;
  width: 80px;
  left: 0px;
  top: 16px;
  border-radius: nullpx;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  background-color: white;
  outline: none;
  border: none;
  color: #66b015;
  cursor: pointer;
}
.FormFooter .Btn.Next {
  background-color: #66b015;
  color: white;
  width: 192px;
}

.Gmap {
  height: 300px;
}

.HEL {
  margin: 2% 0 2% 0;
}
.Error {
  border-color: red;
}
.ErrorMessage {
  color: red;
  font-size: 16px;
  font-family: Montserrat;
}

.create-property-photo-container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.create-property-image-area-container {
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
}

.create-property-drag-area {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 3% 0;
  border: 1px dashed var(--rentalios-dark);
  box-sizing: border-box;
  border-radius: 4px;
}

.create-property-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 22px;
  color: #66b015;
  margin-top: 24px;
}

.create-property-subtitle-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 32px;
  margin-bottom: 24px;
  margin-top: 24px;
}

.create-property-subtitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: #192a3e;
}

.create-property-add-more-button {
  height: 100%;
  width: 132px;
  background: #ffffff;
  border: 1px solid #66b015;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #66b015;
}

.create-property-add-more-button:hover {
  cursor: pointer;
}

.create-property-drag-hint {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #66b015;
  margin-top: 12px;
}
.create-property-upload-button {
  background: var(--rentalios-dark);
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  border: none;
  width: 176px;
  height: 40px;
}
.create-property-upload-button:hover {
  cursor: pointer;
}
.create-property-upload-button:focus {
  outline: 0;
}
.create-property-upload-button:active {
  background-color: #66b015;
}

.create-property-edit-image-container {
  height: 185px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 6px));
  grid-gap: 12px;
  /* margin-top: 24px; */
}

.create-property-edit-image-sub-container {
  position: relative;
}

img.create-property-feature-image {
  position: absolute;
  top: 36px;
  left: 8px;
  z-index: 1;
  width: 32px;
  height: 32px;
}

img.create-property-edit-image {
  position: absolute;
  top: 28px;
  left: 0;
  width: auto;
  height: 150px;
  /* max-height: 100%; */
  max-width: 100%;
  border-radius: 4px;
  object-fit: cover !important;
}
img.create-property-trash-icon {
  position: absolute;
  top: 36px;
  right: 8px;
  z-index: 1;
  width: 32px;
  height: 32px;
}
img.create-property-trash-icon:hover {
  cursor: pointer;
}

progress {
  border-radius: 4px;
  width: 100%;
  height: 12px;
}
progress::-webkit-progress-bar {
  border-radius: 4px;
  background-color: rgba(72, 137, 0, 0.1);
}
progress::-webkit-progress-value {
  border-radius: 4px;
  background-color: #488900;
}

.create-property-feature-image-wrapper {
  position: relative;
}

.create-property-feature-image-wrapper .tooltip {
  visibility: hidden;
  position: absolute;
  z-index: 20;
  background: #66b015;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  color: white;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 12px;
  padding: 8px;
  top: 0px;
  right: 50%;
}

.create-property-feature-image-wrapper:hover .tooltip {
  visibility: visible;
}

select,
option {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
}

.new-property-warning-message {
  display: flex;
  flex-flow: row nowrap;
  justify-content: left;
  width: 100%;
  background: #df000f0d;
  padding: 8px;
  border-radius: 6px;
}
.new-property-warning-message img {
  margin-right: 24px;
}

.new-property-warning-message label {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
  color: #df000f;
}
</style>
